// extracted by mini-css-extract-plugin
export default {"primary_btn":"Primarybtn_primary_btn__nQa8D"};